export default "__VITE_ASSET__0292415f__"